__turbopack_context__.v({
  "arrow": "mainLayout-module-scss-module___0HNQa__arrow",
  "backArrow": "mainLayout-module-scss-module___0HNQa__backArrow",
  "backdrop": "mainLayout-module-scss-module___0HNQa__backdrop",
  "backdrop-show": "mainLayout-module-scss-module___0HNQa__backdrop-show",
  "closeWraperButton": "mainLayout-module-scss-module___0HNQa__closeWraperButton",
  "content": "mainLayout-module-scss-module___0HNQa__content",
  "fade-in-ux308f1": "mainLayout-module-scss-module___0HNQa__fade-in-ux308f1",
  "homeContent": "mainLayout-module-scss-module___0HNQa__homeContent",
  "selectEntitiesButton": "mainLayout-module-scss-module___0HNQa__selectEntitiesButton",
  "selectEntitiesTitleButton": "mainLayout-module-scss-module___0HNQa__selectEntitiesTitleButton",
  "sideBarItemsContainer": "mainLayout-module-scss-module___0HNQa__sideBarItemsContainer",
  "sideBarWrapper": "mainLayout-module-scss-module___0HNQa__sideBarWrapper",
  "skeleton-userName": "mainLayout-module-scss-module___0HNQa__skeleton-userName",
  "subWrapperClientList": "mainLayout-module-scss-module___0HNQa__subWrapperClientList",
  "user": "mainLayout-module-scss-module___0HNQa__user",
  "wrapper": "mainLayout-module-scss-module___0HNQa__wrapper",
});
